import {
  FETCH_PVS_REQUEST,
  FETCH_PVS_FAILURE,
  CREATE_PVS_REQUEST,
  CREATE_PVS_SUCCESS,
  CREATE_PVS_FAILURE,
  UPDATE_PVS_REQUEST,
  UPDATE_PVS_SUCCESS,
  UPDATE_PVS_FAILURE,
  DELETE_PVS_REQUEST,
  DELETE_PVS_SUCCESS,
  DELETE_PVS_FAILURE,
  FETCH_PVS_DETAILS_REQUEST,
  FETCH_PVS_DETAILS_FAILURE,
  FETCH_PVS_CATEGORY_REQUEST,
  FETCH_PVS_CATEGORY_SUCCESS,
  FETCH_PVS_CATEGORY_FAILURE,
  CREATE_PVS_CATEGORY_REQUEST,
  CREATE_PVS_CATEGORY_SUCCESS,
  CREATE_PVS_CATEGORY_FAILURE,
  UPDATE_PVS_CATEGORY_REQUEST,
  UPDATE_PVS_CATEGORY_SUCCESS,
  UPDATE_PVS_CATEGORY_FAILURE,
  FETCH_PVS_CATEGORY_DETAILS_REQUEST,
  FETCH_PVS_CATEGORY_DETAILS_SUCCESS,
  FETCH_PVS_CATEGORY_DETAILS_FAILURE,
  FETCH_PVS_SUBCATEGORY_REQUEST,
  FETCH_PVS_SUBCATEGORY_SUCCESS,
  FETCH_PVS_SUBCATEGORY_FAILURE,
  CREATE_PVS_SUBCATEGORY_REQUEST,
  CREATE_PVS_SUBCATEGORY_SUCCESS,
  CREATE_PVS_SUBCATEGORY_FAILURE,
  UPDATE_PVS_SUBCATEGORY_REQUEST,
  UPDATE_PVS_SUBCATEGORY_SUCCESS,
  UPDATE_PVS_SUBCATEGORY_FAILURE,
  FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST,
  FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS,
  FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE,
  FETCH_PVS_KEYWORD_REQUEST,
  FETCH_PVS_KEYWORD_SUCCESS,
  FETCH_PVS_KEYWORD_DETAILS_SUCCESS,
  FETCH_PVS_BRAND_SUCCESS,
  RESET_PVS_STATE,

  // For Bazaar module
  ALL_BAZAAR_LIST_SUCCESS,
  FETCH_BOOKING_DETAILS_SUCCESS,
  FETCH_PVS_DETAILS_SUCCESS,
  FETCH_PVS_SUCCESS,
  FETCH_STALL_LIST_SUCCESS,
  GET_BOOKING_LIST_SUCCESS,
  GET_USER_BILLING_INFO_SUCCESS,
  DOWNLOAD_INVOICES_SUCCESS,
  DOWNLOAD_BOOKING_REPORT_SUCCESS,
  DOWNLOAD_BALANCE_REPORT_SUCCESS,
  GET_PVS_DETAILS_SUCCESS,
  UPDATE_PVS_REGISTRATION_SUCCESS,
  RESET_PVS_REGISTRATION,
  GET_BAZAAR_STALL_DETAILS_SUCCESS,
  GET_PAYMENT_STATISTICS_SUCCESS,
  DOWNLOAD_BALANCE_REPORT_RESET,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  DOWNLOAD_BOOKING_REPORT_RESET,
} from "../../redux/types/pvs"

const initialState = {
  pvsDetail: {},
  categoryList: [],
  subcategoryList: [],
  keywordList: [],
  brandList: [],
  categoryDetail: {},
  subcategoryDetail: {},
  keywordsDetail: {},

  //pvs registration
  pvsFormData: null,

  // For Bazaar module
  pvsDetails: null,
  allPvsList: [],
  approvedPvsList: [],
  pendingPvsList: [],
  clarificationPvsList: [],
  rejectedPvsList: [],
  paidPvsList: [],
  stallList: [],
  bazaarList: [],
  bookingList: [],
  bookingInfo: null,
  billingInfo: null,
  invoicesZipFileLink: null,
  bookingReport: [],
  balanceReport: [],
  bookingReportFileLink: null,
  balanceReportFileLink: null,
  stallDetails: null,
  paymentStatistics: [],

  // Product state
  productList: [],
  productDetails: null,
}

const authReducer = function (state = initialState, action) {
  switch (action.type) {
    case RESET_PVS_REGISTRATION:
      return {
        ...state,
        pvsFormData: null,
      }
    case UPDATE_PVS_REGISTRATION_SUCCESS:
      return {
        ...state,
        pvsFormData: action.payload.data,
      }
    case GET_PVS_DETAILS_SUCCESS:
      return {
        ...state,
        pvsFormData: action.payload.pvsData,
      }

    case CREATE_PVS_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_PVS_SUCCESS:
      return {
        ...state,
      }

    case DELETE_PVS_SUCCESS:
      return {
        ...state,
      }

    case FETCH_PVS_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryList: action.payload.pvsCategory,
      }
    case FETCH_PVS_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        categoryDetail: action.payload.pvsCategoryDetail,
      }
    case FETCH_PVS_KEYWORD_SUCCESS:
      return {
        ...state,
        keywordList: action.payload.pvsKeyword,
      }
    case FETCH_PVS_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        subcategoryList: action.payload.pvsSubcategory,
      }
    case FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        subcategoryDetail: action.payload.pvsSubcategoryDetail,
      }
    case FETCH_PVS_KEYWORD_DETAILS_SUCCESS:
      return {
        ...state,
        keywordsDetail: action.payload.pvsKeywordDetail,
      }
    case FETCH_PVS_BRAND_SUCCESS:
      return {
        ...state,
        brandList: action.payload.pvsBrand,
      }

    case RESET_PVS_STATE:
      return {
        ...initialState,
      }

    // For Bazaar module
    case FETCH_PVS_SUCCESS:
      console.log("action.payload", action.payload)
      return {
        ...state,
        allPvsList:
          action.payload.all !== undefined
            ? action.payload.all
            : state.allPvsList,
        approvedPvsList:
          action.payload.approved !== undefined
            ? action.payload.approved
            : state.approvedPvsList,
        pendingPvsList:
          action.payload.pending !== undefined
            ? action.payload.pending
            : state.pendingPvsList,
        clarificationPvsList:
          action.payload.clarification !== undefined
            ? action.payload.clarification
            : state.clarificationPvsList,
        rejectedPvsList:
          action.payload.rejected !== undefined
            ? action.payload.rejected
            : state.rejectedPvsList,
        paidPvsList:
          action.payload.paid !== undefined
            ? action.payload.paid
            : state.paidPvsList,
      }
    case FETCH_STALL_LIST_SUCCESS:
      return {
        ...state,
        stallList: action.payload.bazaarStallList,
      }
    case FETCH_PVS_DETAILS_SUCCESS:
      return {
        ...state,
        pvsDetails: action.payload.pvsDetails,
      }
    case ALL_BAZAAR_LIST_SUCCESS:
      return {
        ...state,
        bazaarList: action.payload.bazaar,
      }
    case GET_BOOKING_LIST_SUCCESS:
      return {
        ...state,
        bookingList: action.payload.bookings,
      }
    case FETCH_BOOKING_DETAILS_SUCCESS:
      return {
        ...state,
        bookingInfo: action.payload.bookingInfo,
      }
    case GET_USER_BILLING_INFO_SUCCESS:
      return {
        ...state,
        billingInfo: action.payload.billingInfo,
      }
    case DOWNLOAD_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesZipFileLink: action.payload.invoicesZipFileLink,
      }
    case DOWNLOAD_BOOKING_REPORT_SUCCESS:
      if (action.payload.type === "excel") {
        return {
          ...state,
          bookingReportFileLink: action.payload.bookingReportFileLink,
        }
      } else {
        return {
          ...state,
          bookingReport: action.payload.bookingReport,
        }
      }
    case DOWNLOAD_BALANCE_REPORT_SUCCESS:
      if (action.payload.type === "excel") {
        return {
          ...state,
          balanceReportFileLink: action.payload.balanceReportFileLink,
        }
      } else {
        return {
          ...state,
          balanceReport: action.payload.balanceReport,
        }
      }
    case GET_BAZAAR_STALL_DETAILS_SUCCESS:
      return {
        ...state,
        stallDetails: action.payload.stallDetails,
      }
    case GET_PAYMENT_STATISTICS_SUCCESS:
      return {
        ...state,
        paymentStatistics: action.payload.paymentStatistics,
      }
    case DOWNLOAD_BALANCE_REPORT_RESET:
      return {
        ...state,
        balanceReportFileLink: null,
      }
    case DOWNLOAD_BOOKING_REPORT_RESET:
      return {
        ...state,
        bookingReportFileLink: null,
      }

    // Product cases
    case FETCH_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        productList: action.payload.products,
      })
    case FETCH_PRODUCT_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        productDetails: action.payload.productDetails,
      })

    default:
      return state
  }
}

export default authReducer
